"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatNumberK = exports.fixedNumber = exports.formatNumberRoundUpToNearest = exports.formatNumberRoundDownToNearest = exports.isValidNumber = exports.isEmpty = void 0;
const i18n_1 = require("@tcc/i18n");
const isEmpty = (value) => Number.isNaN(value) || value === null || value === undefined || value === '';
exports.isEmpty = isEmpty;
const isValidNumber = (value) => Number.isFinite(value) && !(0, exports.isEmpty)(value);
exports.isValidNumber = isValidNumber;
const formatNumberRoundDownToNearest = (value, roundValue) => {
    if ((0, exports.isValidNumber)(value) && (0, exports.isValidNumber)(roundValue) && roundValue !== 0) {
        return Math.floor(value / roundValue) * roundValue;
    }
    return value;
};
exports.formatNumberRoundDownToNearest = formatNumberRoundDownToNearest;
const formatNumberRoundUpToNearest = (value, roundValue) => {
    if ((0, exports.isValidNumber)(value) && (0, exports.isValidNumber)(roundValue) && roundValue !== 0) {
        return Math.ceil(value / roundValue) * roundValue;
    }
    return value;
};
exports.formatNumberRoundUpToNearest = formatNumberRoundUpToNearest;
const fixedNumber = (value) => (Math.abs(value) >= 1000 ? `${(value / 1000).toFixed(1)}K` : value.toFixed(1)).toLocaleString();
exports.fixedNumber = fixedNumber;
const formatNumberK = (value, precision = 1) => {
    if (!(0, exports.isValidNumber)(value)) {
        return String(value);
    }
    const options = {
        minimumFractionDigits: precision,
        maximumFractionDigits: precision
    };
    if (Math.abs(value) >= 1000) {
        const localizedValue = (value / 1000).toLocaleString(i18n_1.locale, options);
        return (0, i18n_1.getMessage)('text__number-with-thousands', { num: localizedValue });
    }
    return value.toLocaleString(i18n_1.locale, options);
};
exports.formatNumberK = formatNumberK;
